import { useLang } from "../context/LanguageContext";

export default function LanguageToggle({ className = "" }) {
  const { lang, changeLang } = useLang();
  return (
    <div
      data-testid="lang-toggle"
      className={`inline-flex items-center rounded-full border border-slate-200 bg-white p-0.5 text-xs font-semibold ${className}`}
    >
      {["nl", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-toggle-${l}`}
          onClick={() => changeLang(l)}
          className={`rounded-full px-3 py-1.5 uppercase tracking-wide transition-all duration-300 ${
            lang === l ? "bg-u-ink text-white" : "text-slate-400 hover:text-u-ink"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
